import { render, staticRenderFns } from "./how-to-pay-detail.vue?vue&type=template&id=700b6823"
import script from "./how-to-pay-detail.vue?vue&type=script&lang=js"
export * from "./how-to-pay-detail.vue?vue&type=script&lang=js"
import style0 from "./how-to-pay-detail.vue?vue&type=style&index=0&id=700b6823&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports